import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { assetUrl } from "../../utils/api";
import { ClickableImage, useImageLightbox } from "../../components/ImageLightbox";

export default function ConsultantDetail() {

  const { id } = useParams();
  const consultantId = localStorage.getItem("consultant_id");
  const [consultant, setConsultant] = useState(null);
  const [loading, setLoading] = useState(true);

  const avatarSrc = consultant
    ? assetUrl(consultant.avatar) || "/default-avatar.png"
    : "";
  const { openAt, lightbox } = useImageLightbox(avatarSrc ? [avatarSrc] : []);

  useEffect(() => {
    fetchConsultant();
  }, []);

  const fetchConsultant = async () => {
    try {
      const res = await fetch(
        `/api/consultant/profile/${consultantId}?owner_consultant_id=${consultantId}`
      );

      const data = await res.json();



      if (res.ok) {
        setConsultant(data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        加载中...
      </div>
    );
  }

  if (!consultant) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        咨询师不存在
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-pink-50 py-10 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow p-8">

        <div className="flex flex-col items-center">
          <ClickableImage
            src={avatarSrc}
            alt="头像"
            className="w-32 h-32 rounded-full object-cover border"
            onOpen={() => openAt(0)}
          />

          <h1 className="text-3xl font-bold mt-4">
            {consultant.name}
          </h1>

          <p className="text-gray-500 mt-2">
            {consultant.city} · {consultant.age}岁 ·{" "}
            {consultant.gender}
          </p>
        </div>

        <div className="mt-10 space-y-6">
          <div>
            <h2 className="font-bold text-xl mb-2">
              专业背景
            </h2>
            <p>{consultant.background}</p>
          </div>

          <div>
            <h2 className="font-bold text-xl mb-2">
              擅长领域
            </h2>
            <p>{consultant.specialties}</p>
          </div>

          <div>
            <h2 className="font-bold text-xl mb-2">
              咨询风格
            </h2>
            <p>{consultant.consultation_style}</p>
          </div>

          <div>
            <h2 className="font-bold text-xl mb-2">
              个人介绍
            </h2>
            <p>{consultant.intro}</p>
          </div>
        </div>

        <div className="mt-10 border-t pt-6 flex justify-between items-center">
          <div>
            <p className="text-lg font-bold text-pink-600">
              ￥{consultant.price} / {consultant.duration}分钟
            </p>
          </div>

          <button className="bg-pink-500 hover:bg-pink-600 text-white px-6 py-3 rounded-lg">
            立即预约
          </button>
        </div>
      </div>
      {lightbox}
    </div>
  );
}